import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '../../../useApiMutation';
import keys from './keys';

const useDeleteMarketplaceProfile = () => {
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId, profileId }) => `/shows/${showId}/marketplace/profiles/${profileId}`,
    method: 'DELETE',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.showProfiles({ showId: data.showId }));
    },
  });

  return {
    deleteShowProfile: mutation.mutate,
    isDeleteShowProfileLoading: mutation.isLoading,
    isDeleteShowProfileError: mutation.isError,
    isDeleteShowProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useDeleteMarketplaceProfile;
